module.exports = __webpack_public_path__ + "img/multibanco.9f5c1736.png";